// src/components/Footer.jsx
const Footer = () => (
  <footer className="text-center text-gray-500 text-sm mt-auto py-6 px-4">
    &copy; {new Date().getFullYear()} <span className="font-semibold text-blue-600">CodeWithRomi LLC</span>. All rights reserved.
    <p className="mt-2 flex flex-wrap justify-center gap-3 sm:gap-4">
      <a href="/terms" className="text-gray-500 hover:text-blue-600 transition">Terms</a>
      <a href="/privacy" className="text-gray-500 hover:text-blue-600 transition">Privacy</a>
      <a href="mailto:contact@codewithromi.com" className="text-gray-500 hover:text-blue-600 transition">Contact</a>
    </p>
    <p className="mt-1 text-xs text-gray-400">
      Built with ❤️ using Firebase and OpenAI
    </p>
  </footer>
);
  
export default Footer;